module.exports = __webpack_public_path__ + "static/media/screen.f6b21666.svg";